import { Input } from "@/app/admin/_common/ui/input";
import { Label } from "@/app/admin/_common/ui/label";
import { Controller } from "react-hook-form";

interface LocationInputProps {
  control: any;
  errors: any;
}

function TextInput({
  control,
  errors,
  name,
  label,
  placeholder,
}: LocationInputProps & { name: string; label: string; placeholder: string }) {
  return (
    <div className="grid gap-3">
      <Label htmlFor={name}>{label}</Label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Input id={name} {...field} value={field.value ?? ""} placeholder={placeholder} />
        )}
      />
      {errors[name] && (
        <span className="text-[12px] text-red-600">{errors[name]?.message}</span>
      )}
    </div>
  );
}

export const NameInput = (props: LocationInputProps) => (
  <TextInput {...props} name="name" label="Name" placeholder="Name" />
);

export const Address1Input = (props: LocationInputProps) => (
  <TextInput
    {...props}
    name="address_line_1"
    label="Address Line 1"
    placeholder="Address Line 1"
  />
);

export const Address2Input = (props: LocationInputProps) => (
  <TextInput
    {...props}
    name="address_line_2"
    label="Address Line 2"
    placeholder="Address Line 2"
  />
);

export const CityInput = (props: LocationInputProps) => (
  <TextInput {...props} name="city" label="City" placeholder="City" />
);

export const StateInput = (props: LocationInputProps) => (
  <TextInput {...props} name="state" label="State" placeholder="State" />
);

export const ZipInput = (props: LocationInputProps) => (
  <TextInput {...props} name="zip" label="Zip" placeholder="Zip" />
);
